import { useEffect, useState } from 'react';

/**
 * Territorial reading state for the exploration map panel.
 * Progresses through the reading narrative instead of showing a generic
 * spinner — this is the map's light version of the assistant's ceremony.
 */

const MESSAGES = [
  'Leyendo este lugar…',
  'Buscando referencias del entorno…',
  'Preparando la ficha del lugar…',
] as const;

const STEP_MS = 1100;

export function VsjMapReadingState(): JSX.Element {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIdx(i => (i < MESSAGES.length - 1 ? i + 1 : i));
    }, STEP_MS);
    return () => {
      window.clearInterval(timer);
    };
  }, []);

  return (
    <div className="vsj-map-reading" role="status">
      <div className="vsj-map-reading-line" aria-hidden="true" />
      <p className="vsj-map-reading-msg" key={idx}>
        {MESSAGES[idx]}
      </p>
    </div>
  );
}
